import { COMPONENT_NAME_PREFIX } from '../constants';

const elementName: keyof HTMLElementTagNameMap = `${COMPONENT_NAME_PREFIX}page-state`;

export const PAGE_STATE_CONSTANTS = {
  elementName
};
